import * as React from 'react';
import { SetTooltipProps } from '../controls';

export interface AppContextType {
  isExperimentalFeatureEnabled?: (feature: string, defaultValue?: boolean) => boolean;
  setTooltipElement?: (tooltipProps: SetTooltipProps) => void;
  updateTooltipsHidden?: (hideAllTooltips: boolean) => void;
}

export const AppContext: React.Context<AppContextType> = React.createContext({});
AppContext.displayName = 'AppContext';
